import React from 'react';
import '../../Styles/Annotator/ubersicht.css';
import {getReportLink} from '../../API/report';
import { Col } from 'react-bootstrap';
import { getOut, hasToken } from '../../Utils/Common';
import PieGraphWebReport from '../Report/PieGraphWebReport';


/**
 * This class generates all bar graphes needed on the page Übersicht
 * Code example: https://jsfiddle.net/CrossEye/rnLnqq3g/
 */
class FirstPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reportData: [],
            imgReportData: [],
            pieChartData: [],
            load: false,
            width: 500,
            height: 500,
            title: 'title',
            piegraphValue: [],
            piegraphAngle: [],
            colorData: { Hinweis: '#FFD60A', Potenzial: '#1ABC9C', Risiko: '#E95849' },
            steps_data: []
        };
    }

    //
    // set_steps(reporttable, risiko_width_rec, potenzial_width_rec) {
    //     let max_val = risiko_width_rec;
    //     let steps_euro = -reporttable.imgdata.price_of_risiko / 4;
    //     if (risiko_width_rec < potenzial_width_rec) {
    //         max_val = potenzial_width_rec;
    //         steps_euro = reporttable.imgdata.price_of_potenzial / 4;
    //     }
    //     let steps_potenzial = [],
    //         steps_risiko = [];
    //     let tmp_max_val = max_val / 4;
    //     let tmp_steps_euro = steps_euro;
    //     while (tmp_max_val < max_val) {
    //         if (tmp_steps_euro < reporttable.imgdata.price_of_potenzial) {
    //             steps_potenzial.push({
    //                 'labelText': tmp_steps_euro.toLocaleString('de-DE') + '€',
    //                 'step_size': tmp_max_val
    //             });
    //         }
    //         let tmp_neg = -tmp_steps_euro;
    //         if (tmp_steps_euro < (-reporttable.imgdata.price_of_risiko)) {
    //             steps_risiko.push({ 'labelText': tmp_neg.toLocaleString('de-DE') + '€', 'step_size': -tmp_max_val });
    //         }
    //         tmp_max_val = tmp_max_val + max_val / 4;
    //         tmp_steps_euro = tmp_steps_euro + steps_euro;
    //
    //     }
    //     this.setState({ steps_data: steps_risiko.concat(steps_potenzial) });
    // }

    // render_bargraph(reporttable) {
    //     const tmp_total = reporttable.imgdata.price_of_potenzial - reporttable.imgdata.price_of_risiko;
    //     // if the price of the potenzial and the risiko equal to 0... we set the variable to 1
    //     let total = tmp_total !== 0 ? tmp_total : 1;
    //     const risiko_perc = (reporttable.imgdata.price_of_risiko * 100) / total;
    //     const potential_perc = (reporttable.imgdata.price_of_potenzial * 100) / total;
    //     const risiko_width_rec = -risiko_perc * 200 / 100;
    //     const potenzial_width_rec = potential_perc * 200 / 100;
    //     let imgReportData = [{
    //         'width_rec': risiko_width_rec,
    //         'labelText': reporttable.imgdata.price_of_risiko.toLocaleString('de-DE') + '€',
    //         color: this.state.colorData.Risiko
    //     },
    //         {
    //             'width_rec': potenzial_width_rec,
    //             'labelText': reporttable.imgdata.price_of_potenzial.toLocaleString('de-DE') + '€',
    //             color: this.state.colorData.Potenzial
    //         }
    //     ];
    //     this.setState({ imgReportData: imgReportData });
    //     this.set_steps(reporttable, risiko_width_rec, potenzial_width_rec);
    // }

    async componentDidMount() {
        hasToken();
        let path = window.location.pathname;
        let lvID = path.split('/')[2];
        //let reporttable = await getStatistics(lvID);
        let reporttable = await getReportLink(lvID)

        reporttable = reporttable.response;
        if (reporttable === undefined) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        }
        //this.render_bargraph(reporttable);
        this.setState({ reportData: reporttable });
        this.setState({ pieChartData: reporttable.stats });

        this.props.setProjectName(this.state.reportData.projectName);

        //let link = this.state.reportData.link;
        //let lvID = '';
        //link = link.split('/');
        //lvID = link[link.length - 2];
        this.props.setLvID(lvID);

    }

    render() {
        return (
            <>
                <div className='outerContainer container'>
                    <br />
                    <Col className='firstPageColumn'>
                        <h3 className='firstPageProjectName'> LV-Analyse: {this.state.reportData.projectName}</h3>
                        <div className='block_container marginRight'
                        >
                            {/*<div className="graph-div text-center backgroundWebReportImage"
                            >
                                <svg width={this.state.width} height={this.state.height}
                                     viewBox={`-${(this.state.width - this.state.height) / 2} 0 ${this.state.width} ${this.state.height}`}
                                     >
                                    <BarGraphWebReport imgReportData={this.state.imgReportData}
                                                       steps_data={this.state.steps_data}/>
                                </svg>
                            </div>*/}
                            <div className='piechartImage graph-div text-center backgroundWebReportImage'
                            >
                                <svg width={this.state.width} height={this.state.height}
                                     viewBox={`-${(this.state.width - this.state.height) / 2} 0 ${this.state.width} ${this.state.height}`}
                                     color='white'>
                                    <PieGraphWebReport pieChartData={this.state.pieChartData}
                                                       colorData={this.state.colorData} />
                                    <text className='webReportImageTitleStyle' x={240} y={40} dominantBaseline='middle'
                                          textAnchor='middle' fill='black'>Übersicht Analyse
                                    </text>
                                </svg>
                            </div>
                            <br /> <br /> <br />
                        </div>
                        <div className='processBox'>
                            Die Hinweise solltest Du nutzen, um Fragen mit dem Auftraggeber zu klären und weitere
                            Potenziale
                            zu
                            identifizieren. Überprüfe die von uns aufgezeigten möglichen Potenziale, um zu sehen, welche
                            sich
                            davon für Dich realisieren lassen. Schaue Dir die Risiken an, damit Du nicht unnötig Geld
                            verlierst.
                            Die Analyse beruht auf künstlicher Intelligenz und hat keinen Anspruch auf Vollständigkeit.
                            Sie
                            stellt keine Rechtsberatung dar, sondern analysiert Leistungsverzeichnisse aus der
                            praktischen
                            Perspektive als Unterstützung für Deine vertriebliche Entscheidung. Als Basis unserer
                            Analyse
                            wurde
                            das bereitgestellte Leistungsverzeichnis verwendet. Weitere Unterlagen und Informationen
                            werden
                            bei
                            der Analyse nicht berücksichtigt.
                        </div>
                    </Col>
                </div>
            </>
        );
    }
}

export default FirstPage;